import React, { Component, Fragment } from 'react';
import DEFINE, { PATHS, FEATURE_FLAGS } from "../../../../../constants/Define";
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { PageListComponent, HeaderListComponent, } from "../../../common/component/Index";
import { Icon, Rate } from 'antd';
import TagGroupDetailList from './TagGroupDetailList';
import moment from 'moment'
import Ripple from '../../../common/component/Ripple';

let permisionActions = [];
export default class TagGroupDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      params: {
        pageSize: this.props.tagGroupDetailState.pageSize,
        pageIndex: this.props.tagGroupDetailState.pageIndex,
      },
    };
  }

  componentDidMount() {
    permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.TAG_GROUP_DETAIL);
    this.props.getListTagGroupDetails(this.state.params);
    if (!this.props.tagGroupState.allTagGroups.length) {
      this.props.getAllTagGroup()
    }
  }

  render() {
    const { t } = this.props;
    const { allTagGroups } = this.props.tagGroupState;
    const { isFetching, totalCount, totalPage, pageIndex, pageSize, tagGroupDetails, filters, order } = this.props.tagGroupDetailState;
    const pagination = { total: totalCount, totalPage, defaultCurrent: pageIndex, defaultPageSize: pageSize };
    return (
      <Fragment>
        <PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
          <HeaderListComponent
            path={this.props.match.path}
            groupPath={'tagGroupDetails'}
            titleHeader={t('navigation.tagGroupDetails')}
            componentRight={
              <Fragment>{
                permisionActions && permisionActions.allowCreate && FEATURE_FLAGS.CREATE_TAG_GROUP_DETAIL_ENABLE &&
                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                  <Link to={PATHS.TAG_GROUP_DETAIL.CREATE.path}
                    className='btn btn-primary'>+ {t(`action.create`)}</Link>
                </Ripple>
              }
              </Fragment>
            }
          />
          <TagGroupDetailList loading={isFetching}
            permisions={permisionActions}
            tagGroupDetails={tagGroupDetails}
            tagGroups={allTagGroups}
            pagination={pagination}
            onChange={this.onTableChange}
            onDelete={this.onDeleteTagGroupDetail}
          />
        </PageListComponent>
      </Fragment>
    );
  }

  onTableChange = (pagination, filters, sorter) => {
    let curfilters = this.state.filters;
    if (filters.status) {
      switch (filters.status[0]) {
        case 998:
          filters = Func.removeElementObject(filters, 'status');
          curfilters = Func.removeElementObject(curfilters, 'status');
          curfilters = Func.removeElementObject(curfilters, 'isExpired');
          filters.IsLocked = true;
          break;
        case 999:
          filters = Func.removeElementObject(filters, 'status');
          curfilters = Func.removeElementObject(curfilters, 'status');
          curfilters = Func.removeElementObject(curfilters, 'IsLocked');
          filters.isExpired = true;
          break;
        default:
          if (filters.status[0] !== 998) { curfilters = Func.removeElementObject(curfilters, 'IsLocked') }
          if (filters.status[0] !== 999) { curfilters = Func.removeElementObject(curfilters, 'isExpired') }
      }
    }
    let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
    this.setState({
      params: newFilters
    });
    this.props.getListTagGroupDetails(newFilters);
  };

  onDeleteTagGroupDetail = (tagGroupDetail) => {
    this.props.deleteTagGroupDetail(tagGroupDetail, this.state.params)
  }

  onChangeLanguage = (language) => {
    this.props.getListTagGroupDetails(this.state.filters)
  }


}
